export default (exp) => {
    const currentTime = Math.floor(Date.now());
    // If token expires in next 60 seconds then deem it invalid.
    return exp * 1000 - 60 < currentTime;
};
